import { render, staticRenderFns } from "./WhyDontYouMakeMeMoveMyMouseToGenerateASeed.vue?vue&type=template&id=07235df3&scoped=true&"
import script from "./WhyDontYouMakeMeMoveMyMouseToGenerateASeed.vue?vue&type=script&lang=js&"
export * from "./WhyDontYouMakeMeMoveMyMouseToGenerateASeed.vue?vue&type=script&lang=js&"
import style0 from "./WhyDontYouMakeMeMoveMyMouseToGenerateASeed.vue?vue&type=style&index=0&id=07235df3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07235df3",
  null
  
)

export default component.exports